import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["data-postfix"]
const _hoisted_3 = ["id", "value"]
const _hoisted_4 = ["for"]
const _hoisted_5 = ["data-postfix"]
const _hoisted_6 = ["id", "value", "min", "max"]
const _hoisted_7 = ["for"]
const _hoisted_8 = ["data-postfix"]
const _hoisted_9 = ["id", "value"]
const _hoisted_10 = ["for"]
const _hoisted_11 = ["data-postfix"]
const _hoisted_12 = ["id", "value", "min", "max"]
const _hoisted_13 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiRangeSlider = _resolveComponent("MultiRangeSlider")!

  return (_openBlock(), _createElementBlock("fieldset", {
    class: _normalizeClass(_ctx.customClass)
  }, [
    _createElementVNode("legend", { innerHTML: _ctx.label }, null, 8, _hoisted_1),
    _createVNode(_component_MultiRangeSlider, {
      min: _ctx.minValueAvailable,
      max: _ctx.maxValueAvailable,
      minValue: _ctx.minValue,
      maxValue: _ctx.maxValue,
      step: _ctx.step,
      ruler: false,
      label: false,
      onInput: _ctx.sliderUpdate
    }, null, 8, ["min", "max", "minValue", "maxValue", "step", "onInput"]),
    _createElementVNode("div", null, [
      (_ctx.formatToCurrency)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "multirange-input",
            "data-postfix": _ctx.inputPostfix
          }, [
            _createElementVNode("input", {
              id: _ctx.minId,
              type: "text",
              value: _ctx.minValue.toLocaleString(_ctx.localeStrings.longName),
              onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.formatValue && _ctx.formatValue(...args))),
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.minValueUpdate && _ctx.minValueUpdate(...args))),
              onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.minFocus && _ctx.minFocus(...args))),
              onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.minEmptyCheck && _ctx.minEmptyCheck(...args)))
            }, null, 40, _hoisted_3),
            _createElementVNode("label", { for: _ctx.minId }, _toDisplayString(_ctx.minLabel), 9, _hoisted_4)
          ], 8, _hoisted_2))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "multirange-input",
            "data-postfix": _ctx.inputPostfix
          }, [
            _createElementVNode("input", {
              id: _ctx.minId,
              type: "number",
              value: _ctx.minValue,
              min: _ctx.minValueAvailable,
              max: _ctx.maxValueAvailable,
              onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.minValueUpdate && _ctx.minValueUpdate(...args))),
              onFocus: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.minFocus && _ctx.minFocus(...args))),
              onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.minEmptyCheck && _ctx.minEmptyCheck(...args)))
            }, null, 40, _hoisted_6),
            _createElementVNode("label", { for: _ctx.minId }, _toDisplayString(_ctx.minLabel), 9, _hoisted_7)
          ], 8, _hoisted_5)),
      (_ctx.formatToCurrency)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "multirange-input",
            "data-postfix": _ctx.inputPostfix
          }, [
            _createElementVNode("input", {
              id: _ctx.maxId,
              type: "text",
              value: _ctx.maxValue.toLocaleString(_ctx.localeStrings.longName),
              onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.formatValue && _ctx.formatValue(...args))),
              onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.maxValueUpdate && _ctx.maxValueUpdate(...args))),
              onFocus: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.maxFocus && _ctx.maxFocus(...args))),
              onBlur: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.maxEmptyCheck && _ctx.maxEmptyCheck(...args)))
            }, null, 40, _hoisted_9),
            _createElementVNode("label", { for: _ctx.maxId }, _toDisplayString(_ctx.maxLabel), 9, _hoisted_10)
          ], 8, _hoisted_8))
        : (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: "multirange-input",
            "data-postfix": _ctx.inputPostfix
          }, [
            _createElementVNode("input", {
              id: _ctx.maxId,
              type: "number",
              value: _ctx.maxValue,
              min: _ctx.minValueAvailable,
              max: _ctx.maxValueAvailable,
              onInput: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.formatValue && _ctx.formatValue(...args))),
              onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.maxValueUpdate && _ctx.maxValueUpdate(...args))),
              onFocus: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.maxFocus && _ctx.maxFocus(...args))),
              onBlur: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.maxEmptyCheck && _ctx.maxEmptyCheck(...args)))
            }, null, 40, _hoisted_12),
            _createElementVNode("label", { for: _ctx.maxId }, _toDisplayString(_ctx.maxLabel), 9, _hoisted_13)
          ], 8, _hoisted_11))
    ])
  ], 2))
}